import React, { useEffect } from 'react';
import DatePicker from "react-datepicker";
import Select from 'react-select';

import ButtonLoading from '../../components/Loder/buttonLoading';
import { getTrans as t } from "../../Localization/translations";
import { API } from '../../backend';
import authHeader from '../../services/auth-header';
import { ToastContainer } from "react-toastify";


const Scheduler = ({ showScheduler,
    setShowScheduler,
    setScheduleType,
    scheduleType,
    setStartDate,
    startDate,
    setStartTime,
    startTime,
    setEndDate,
    endDate,
    setEndTime,
    endTime,
    setRerunInterval,
    rerunInterval,
    setRerunUnit,
    rerunUnit,
    setSelectedMonths,
    selectedMonths,
    setSelectedDates,
    selectedDates,
    setFrequency,
    frequency,
    setSelectedWeekdays,
    selectedWeekdays,
    schedule,
    setSchedule,
    setIncrementParams,
    incrementParams,
    setRecalculateParams,
    recalculateParams,
    moniter,
    setMoniter,
    selectedValue,
    onSave,
    billtroughdate, GenrateBilltableRef,
    handleschedule,
    setIsLoading,
    isLoading,
    setBillTroughDate,
    options2,
    setOptions2,
    isLoading2,
    setIsLoading2,
    setValue2,
    inputvalue2,
    setCurrentPage2,
    currentPage2,
    setContract_number,
    setSelectedValue,
    error,
    setError
}) => {
    // const [scheduleType, setScheduleType] = useState('once');
    // const [startDate, setStartDate] = useState('');
    // const [startTime, setStartTime] = useState('00:00');
    // const [endDate, setEndDate] = useState('');
    // const [endTime, setEndTime] = useState('23:59');
    // const [rerunInterval, setRerunInterval] = useState('1');
    // const [rerunUnit, setRerunUnit] = useState('hours');

    // const [selectedMonths, setSelectedMonths] = useState([]);
    // const [selectedDates, setSelectedDates] = useState([]);
    // const [frequency, setFrequency] = useState("");
    // const [selectedWeekdays, setSelectedWeekdays] = useState([]);
    // const [incrementParams, setIncrementParams] = useState(false);
    // const [recalculateParams, setRecalculateParams] = useState(false);

    // const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    // const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    // const toggleMonth = (month) => {
    //     if (selectedMonths.includes(month)) {
    //         setSelectedMonths(selectedMonths.filter(m => m !== month));
    //     } else {
    //         setSelectedMonths([...selectedMonths, month]);
    //     }
    // };

    // const toggleDate = (date) => {
    //     setSelectedDates((prev) =>
    //         prev.includes(date) ? prev.filter((d) => d !== date) : [...prev, date]
    //     );
    // };

    // const toggleWeekday = (dayIndex) => {
    //     setSelectedWeekdays((prev) =>
    //         prev.includes(dayIndex) ? prev.filter((day) => day !== dayIndex) : [...prev, dayIndex]
    //     );
    // };

    useEffect(() => {
        const currentDate = new Date();

        const formattedDate = currentDate.toISOString().split('T')[0];

        const formattedTime = currentDate.toTimeString().slice(0, 5);

        setStartDate(formattedDate);
        setStartTime(formattedTime);
    }, []);

    useEffect(() => {
        setIsLoading(false);
    }, [scheduleType]);

    const handleInputChangeData = (value) => {
        setValue2(value);
        setCurrentPage2(1);
        setOptions2([]);
        loadOptionsData(value, 1);
    };

    const loadOptionsData = async (value, page) => {
        try {
            if (value !== '') {
                setIsLoading2(true);
                const response = await fetch(`${API}contracts/contractsactive/filter/?id=${value}&page=${page}`, { headers: authHeader() });
                const newData = await response.json();

                if (newData && newData.data && newData.data.length > 0) {
                    const newOptions = newData.data

                    setOptions2((prevOptions) => [...prevOptions, ...newOptions]);
                    setCurrentPage2((prevPage) => prevPage + 1);
                } else {
                    console.error('No data received or empty array from API.');
                }
                setIsLoading2(false);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            setIsLoading2(false);
        }
    };

    const handleMenuScrollToBottom = () => {
        loadOptionsData(inputvalue2, currentPage2);
    };

    const handelChange2 = (value1) => {
        setSelectedValue(value1);
        setContract_number(value1)
    };

    const handleOnchage = (e) => {
        setMoniter(e.target.value);
    };
    const handleOnchangeFrequncy = (e) => {
        setError(false)
        setRerunUnit(e.target.value)
    }

    return (
        <div>
            <ToastContainer />
            {showScheduler && (
                <div className={`modal fade  ${showScheduler ? 'show' : 'Close'}`}
                    style={{ display: showScheduler ? 'block' : 'none' }} id="scheduleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden={!showScheduler}>
                    <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable w-100" style={{ maxWidth: '50%', width: '400px', margin: '0 auto', }}>
                        <div className="modal-content" style={{ overflowY: 'auto', }}>
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">Scheduler</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" style={{ backgroundColor: 'red' }}
                                    onClick={() => {
                                        setShowScheduler(false); setSchedule({});
                                        setStartDate('');
                                        setScheduleType('instant')
                                        setStartTime('00:00');
                                        setEndDate('')
                                        setEndTime('')
                                        setRerunInterval('')
                                        setRerunUnit('')
                                        setSelectedMonths([])
                                        setSelectedDates([])
                                        setFrequency("")
                                        setSelectedWeekdays([])
                                        setIsLoading(false)
                                    }
                                    }></button>
                            </div>
                            <div className="modal-body" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                <div className="card-body">
                                    <div value={moniter} className="col-md-6 pe-1">
                                        <span className="mb-0 col-form-label">
                                            {t("Select Processing")}
                                        </span>
                                        <select value={moniter} className="form-control" onChange={handleOnchage}>
                                            {/* <option value="Billing" selected>{t("Billing")}</option>
                                            <option value="Notification">{t("Notification")}</option>
                                            <option value="Income Recognition">{t("Income Recognition")}</option>
                                            <option value="Bucket">{t("Bucket")}</option> */}
                                            
                                            <option value="Billing" selected>{t("Generate Invoices")}</option>
                                            <option value="Notification">{t("Generate Notifications")}</option>
                                            <option value="Income Recognition">{t("Income Recognition")}</option>
                                            <option value="Bucket">{t("Generate Aging Bucket")}</option>
                                            <option value="ACH">{t("Generate ACH")}</option>
                                            <option value="ACH Return">{t("Generate ACH Return")}</option>
                                            <option value="Fetch QuickFi Data">{t("Fetch QuickFi Data")}</option>
                                            <option value="Contract Bulk Create">{t("Contract Bulk Create(QuickFi)")}</option>
                                            <option value="Bulk Contract Activate">{t("Bulk Contract Activate")}</option>
                                        </select>
                                    </div>
                                    <div className="ms-auto my-auto mt-lg-0 mt-4">
                                        <div className="ms-auto my-auto"></div>
                                    </div>
                                    <div className="card-content">
                                        {/* {scheduleType !== 'specific' && */}
                                        
                                        <div className="col-12 col-md-12 mb-3">
                                            <div className="row">
                                                {
                                                    moniter === "Notification" ?"" :
                                                    // moniter === "ACH" ?"":
                                                    moniter === "ACH Return" ?"":
                                                    moniter === "Fetch QuickFi Data" ?"":
                                                    moniter === "Contract Bulk Create" ?"":
                                                    moniter === "Bulk Contract Activate" ?"":
                                                <div className="col-md-6 pe-1">
                                                    <label className="col-lg-6 col-form-label">
                                                        {t("Contract Number")}
                                                    </label>
                                                    <Select
                                                        value={selectedValue}
                                                        filterOption={false}
                                                        options={options2}
                                                        isClearable
                                                        onInputChange={handleInputChangeData}
                                                        getOptionLabel={(options) => options.contract_number}
                                                        getOptionValue={(options) => options.contract_number}
                                                        isLoading={isLoading2}
                                                        placeholder={t("Search for Contract(%for All)")}
                                                        onMenuScrollToBottom={handleMenuScrollToBottom}
                                                        onChange={handelChange2}
                                                        menuPlacement="auto"
                                                        menuPortalTarget={document.body}
                                                        styles={{
                                                            menuPortal: (base) => ({ ...base, zIndex: 1050 }),
                                                        }}
                                                    />
                                                    <input
                                                        type="hidden"
                                                        id="contract_status"
                                                        value=""
                                                    />
                                                </div>
                                                }

                                                {scheduleType !== 'specific' &&
                                                    
                                                    <div className="col-md-6 pe-1">
                                                         {
                                                   
                                                    moniter === "ACH Return"?"":
                                                    moniter === "Contract Bulk Create"?"":
                                                    moniter === "Bulk Contract Activate"?"":
                                                    <>
                                                        <label className="col-lg-6 col-form-label">
                                                            {moniter === 'Billing' ? t("Bill Through Date") :
                                                                moniter === 'Notification' ? t("Send Through Date") :
                                                                    moniter === 'Income Recognition' ? t("As of Date") :
                                                                        moniter === 'Bucket' ? t("Send Through Date") :
                                                                         moniter === "ACH" ? t("Effective Date") :
                                                                          moniter === "Fetch QuickFi Data" ? t("Last Modified Since (optional)") :
                                                                            t("Bill Through Date")
                                                            }
                                                        </label>
                                                        <DatePicker
                                                            className="form-control datepick"
                                                            selected={billtroughdate}
                                                            onChange={(e) => setBillTroughDate(e)}
                                                            placeholderText={"mm/dd/yyyy"}
                                                            showYearDropdown
                                                            scrollableYearDropdown
                                                            showMonthDropdown
                                                            dropdownMode="select"
                                                            popperPlacement="bottom-start"
                                                            popperModifiers={[
                                                                {
                                                                    name: "preventOverflow",
                                                                    options: {
                                                                        boundary: "viewport",
                                                                    },
                                                                },
                                                            ]}
                                                            portalId="root"
                                                            popperContainer={({ children }) => (
                                                                <div
                                                                    style={{
                                                                        position: "absolute",
                                                                        zIndex: 1060,
                                                                        backgroundColor: "#fff",
                                                                        border: "1px solid #ccc",
                                                                        borderRadius: "4px",
                                                                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                                                    }}
                                                                >
                                                                    {children}
                                                                </div>
                                                            )}
                                                        />
                                                   </>
                                                    }
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        {/* } */}
                                        <div className="radio-group mb-3">
                                            <label className='col-form-label'>
                                                <input
                                                    type="radio"
                                                    value="instant"
                                                    checked={scheduleType === 'instant'}
                                                    onChange={() => setScheduleType('instant')}
                                                />
                                                ASAP
                                            </label>
                                            <label className='col-form-label'>
                                                <input
                                                    type="radio"
                                                    value="once"
                                                    checked={scheduleType === 'once'}
                                                    onChange={() => setScheduleType('once')}
                                                />
                                                Once
                                            </label>
                                            <label className='col-form-label'>
                                                <input
                                                    type="radio"
                                                    value="specific"
                                                    checked={scheduleType === 'specific'}
                                                    onChange={() => setScheduleType('specific')}
                                                />
                                                Periodic
                                            </label>
                                        </div>

                                        {scheduleType !== 'instant' && (
                                            <div className="row">
                                                <div className="col-6 col-md-6 mb-3">
                                                    <label className='col-lg-12 col-form-label'>Schedule Starts</label>
                                                    <div className="d-flex align-items-center">
                                                        <div className="col-md-6 pe-1">
                                                            <input
                                                                type="date"
                                                                className="form-control"
                                                                value={startDate}
                                                                onChange={(e) => setStartDate(e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="col-md-6 ps-1">
                                                            <input
                                                                type="time"
                                                                className="form-control"
                                                                value={startTime}
                                                                placeholder="--:--"
                                                                onChange={(e) => setStartTime(e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                {scheduleType !== 'once' &&
                                                    (
                                                        <div className="col-12 col-md-6 mb-3">
                                                            <label className='col-lg-12 col-form-label'>Schedule Ends</label>
                                                            <div className="d-flex align-items-center">
                                                                <div className="col-6 pe-1">
                                                                    <input
                                                                        type="date"
                                                                        className="form-control"
                                                                        value={endDate}
                                                                        onChange={(e) => setEndDate(e.target.value)}
                                                                    />
                                                                </div>
                                                                <div className="col-6 ps-1">
                                                                    <input
                                                                        type="time"
                                                                        className="form-control"
                                                                        value={endTime}
                                                                        onChange={(e) => setEndTime(e.target.value)}
                                                                    />
                                                                </div>
                                                            </div>

                                                        </div>
                                                    )}
                                                <div className="col-6">
                                                    {scheduleType === 'specific' && (
                                                        <>
                                                            <div className="d-flex align-items-center justify-content-between">
                                                                <div className="mb-3 col-lg-6 " style={{ flex: 1, marginRight: '10px' }}>
                                                                    <label className='col-form-label'>Frequency</label>
                                                                    <select
                                                                        value={rerunUnit}
                                                                        onChange={(e) => handleOnchangeFrequncy(e)}
                                                                        className="unit-select form-control "
                                                                    // style={{ width: '50%' }}
                                                                    >
                                                                        <option value="">---Select---</option>
                                                                        <option value="day">Days</option>
                                                                        <option value="week">Weeks</option>
                                                                        <option value="month">Months</option>
                                                                    </select>
                                                                    {error && <div className="invalid-feedback">Please select a frequency.</div>}
                                                                </div>

                                                            </div>

                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        )}

                                        {/* {scheduleType === 'specific' && (
                                            <>
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <div className="mb-3" style={{ flex: 1, marginRight: '10px' }}>
                                                        <label className='col-form-label'>Frequency</label>
                                                        <select
                                                            value={rerunUnit}
                                                            onChange={(e) => setRerunUnit(e.target.value)}
                                                            className="unit-select form-control"
                                                            style={{ width: '50%' }}
                                                        >
                                                            <option value="">---Select---</option> */}
                                        {/* <option value="minute">Minutes</option> */}
                                        {/* <option value="day">Days</option>
                                                            <option value="week">Weeks</option>
                                                            <option value="month">Months</option>
                                                        </select>
                                                    </div>

                                                </div>

                                            </>
                                        )} */}
                                    </div>

                                    <div className="card-footer d-flex justify-content-between">
                                        <button className="border-0 btn btn-primary btn-gradient" style={{ backgroundColor: 'gray' }}
                                            onClick={() => {
                                                setShowScheduler(false);
                                                setScheduleType('instant');
                                                setSelectedValue(null);
                                                setContract_number('');
                                                setEndDate('')
                                                setEndTime('')
                                                setRerunUnit('')
                                                setError(false)
                                                setBillTroughDate(new Date())

                                            }}
                                        >Cancel</button>
                                        {
                                            isLoading === true
                                        }
                                        <button type="submit"
                                            className="border-0 btn btn-primary btn-gradient-primary" style={{ backgroundColor: 'rgb(36, 92, 127)' }}
                                            disabled={isLoading === true}
                                            onClick={() => {
                                                if (scheduleType === 'instant') {
                                                    onSave();
                                                } else {
                                                    handleschedule();
                                                }
                                            }}
                                        >
                                            {
                                                isLoading === true ? <ButtonLoading /> : 'Save Schedule'
                                            }
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
            }
        </div >
    );
};

export default Scheduler;
